import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Shipping data changes only when someone in the shop does something, and
      // mutations invalidate explicitly. Refetching on every window focus just
      // adds noise mid-label-run.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});
